import styled from "styled-components";
import { breakpoints } from "../../utils/breakpoints";

export default function DetailLine({ color = "#fff" }) {
  return <Line $color={color}></Line>;
}

const Line = styled.div`
  width: 32px;
  border: 2px solid ${(props) => props.$color};
  border-radius: 10px;
  margin-bottom: 16px;

  @media (min-width: ${breakpoints.s}) {
    width: 48px;
  }
`;
